import React, { useState, useEffect } from 'react';
import * as api from '../services/api'
import Loader from '../../components/Loader';
import styles from './manager.module.css';
import back from '../../assets/icons/back.svg';
import InsertBar from '../../components/InsertBar';
import CustomizedModal from '../../components/modal/CustomizedModal';
import { Box, Button } from '@mui/material';
import { useNavigate, useLocation } from "react-router-dom";

function PositionEdit() {
  const [loading, setLoading] = useState(false)
  const location = useLocation();
  const navigate = useNavigate();
  const [position_name, setPositionName] = useState(location.state.position_name);
  const [position_name_short, setPositionNameShort] = useState(location.state.position_name_short);
  const line_number = useState(location.state.line_number)[0];
  const [info, setInfo] = useState({});
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await api.findPosition(null,null,line_number);
    setLoading(false);
    if (res) {
      if (res['data']['code'] === 200) {
        setInfo(res['data']['data'][0]);
      } else {
        //alert(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };

  const handlePrevious = () => {
      navigate('/positionManager');
  };

  const handleError = (msg) => {
    setErrorMessage(msg);
    setShowUpdateModal(false);
  };

  const handleUpdate = async () => {
    setShowUpdateModal(true);
  };
  
  const confirmedUpdate = async () => {
    let body = { ...info };
    body.name = position_name;
    body.value = position_name;
    body.remark = position_name_short;

    setLoading(true);
    const res = await api.updatePosition(body);
    setLoading(false);
  
    if (res) {
      if (res['data']['code'] === 200) {
        setShowUpdateModal(false); 
        handlePrevious() //navigate
      } else {
        handleError(res['data']['message']);
      }
    } else {
      alert("ไม่ตอบสนอง");
    }
  };
  
  const handleCloseModal = () => {
    setShowUpdateModal(false);
  };

  const handleCloseErrorModal = () => setErrorMessage(null);

  return (
    <>
      <Loader loading={loading} />
      {showUpdateModal && (
        <CustomizedModal
          onClose={handleCloseModal}
          apiCall={confirmedUpdate}
          confirmMessage={`ยืนยันที่จะแก้ไขข้อมูล`}
          confirmButtonText={`ยืนยัน`}
        />
      )}
      {errorMessage && (
        <CustomizedModal
          onClose={handleCloseErrorModal}
          confirmMessage={errorMessage}
          apiCall={handleCloseErrorModal} // No action required, just closes
          confirmButtonText={`ตกลง`}
        />
      )}
      <Box className={`${styles.bodyText} ${styles.inlineFlex}`} onClick={handlePrevious}>
        <img src={back} alt="Previous" className={styles.directIcon} />
        กลับไป จัดการยศ
      </Box>
      <Box className={styles.head1Text}>แก้ไขข้อมูลยศ</Box>
      <Box sx={{ border: '1.4px solid #478F96', borderRadius: 2, padding: 4, marginTop: '18px' }}>
        <Box className={styles.head2Text}>ชื่อยศ</Box>
        <InsertBar
          currentValue={position_name}
          setNewValue={setPositionName}
          placeholder="ชื่อยศ"
        />
        <Box className={styles.head2Text} sx={{marginTop: 1}}>ตัวย่อ</Box>
        <InsertBar
          currentValue={position_name_short}
          setNewValue={setPositionNameShort}
          placeholder="ตัวย่อ"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 , marginRight: 4.3}}>
        <Button
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            sx={{ padding: 1, borderRadius: 1.5 }}
        >
          <p style={{ fontWeight: 600, margin: 0, fontSize: 12, padding: '0 40px' }}>บันทึก</p>
        </Button>
      </Box>
    </>
  );
}

export default PositionEdit;
